import React from "react"
import { useShallow } from "zustand/react/shallow"
import { useLanguageStore } from "../../state-management/languageStore"

const LanguageToggle = () => {
    const { language, setLanguage, t } = useLanguageStore(
        useShallow((state) => ({
            language: state.language,
            setLanguage: state.setLanguage,
            t: state.translate,
        })),
    )

    return (
        <div className="space-y-2">
            <h3 className="font-bold fg-color-2">{t("language.title")}</h3>
            <p className="text-sm fg-color-3">
                {t("languageToggle.description")}
            </p>
            <div className="flex gap-2 mt-2">
                <button
                    className={`flex-1 py-2 px-4 rounded-lg border ${language === "sv" ? "bg-neutral-900 text-white dark:bg-white dark:text-neutral-900 border-neutral-900 dark:border-white" : "border-neutral-300 dark:border-neutral-700 fg-color-1"}`}
                    onClick={() => {
                        setLanguage("sv")
                        localStorage.setItem("languagePreference", "sv")
                    }}
                >
                    {t("language.swedish")}
                </button>
                <button
                    className={`flex-1 py-2 px-4 rounded-lg border ${language === "en" ? "bg-neutral-900 text-white dark:bg-white dark:text-neutral-900 border-neutral-900 dark:border-white" : "border-neutral-300 dark:border-neutral-700 fg-color-1"}`}
                    onClick={() => {
                        setLanguage("en")
                        localStorage.setItem("languagePreference", "en")
                    }}
                >
                    {t("language.english")}
                </button>
            </div>
        </div>
    )
}

export default LanguageToggle
